export const SnapToMode = Object.freeze({
  NONE: Symbol('snap-none'),
  EDGE: Symbol('snap-edge'),
  POINTANDEDGE: Symbol('snap-point-edge'),
  SMARTGUIDES: Symbol('smart-guides'),
});
